module.exports = __webpack_public_path__ + "static/partnerBlockFront-5aa47eb730d9daf53f1195b83e60004b.png";